import React, { useEffect, useState, useRef } from "react";
import { Card, Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { setPageTitle } from "../../../app/features/DataSlice";
import HOnePurchaseSummary from "../../../components/HeliorOne/HOnePurchaseSummary";
import HOnePurchaseForm from "../../../components/HeliorOne/HOnePurchaseForm";
import { initialHOneInputData } from "../../../helpers";
import { selectProductData } from "../../../app/features/ProductSlice";
import {
  useGetValueQuery,
  useIsKeyAvailableQuery,
  useGetLatestCurrencyRatesQuery,
} from "../../../app/features/apiSlice";
// import Loader from "../../../components/Loader";

const HeliorOne = () => {
  const pageTitle = "XOne";
  const sessionId = useRef(Date.now()).current;
  const dispatch = useDispatch();
  const data = useSelector(selectProductData);

  const [currency, setCurrency] = useState(data.currency || "CHF");

  const [staticValues, setStaticValues] = useState({});
  const { data: ratesData } = useGetLatestCurrencyRatesQuery({ sessionId });
  const rate = currency === "CHF" ? 1 : (ratesData?.data?.[currency] ?? 1);
  const [inputData, setInputData] = useState({
    ...initialHOneInputData,
    ...data,
  });

  const staticData = useGetValueQuery({ sessionId });

  useEffect(() => {
    if (staticData.isSuccess) {
      const {
        guaranteeMargin,
        txCryptoFee,
        txBankFee,
        stampDuty,
        goldValue,
        manufacturingCost,
      } = staticData.data;
      setInputData((prev) => ({
        ...prev,
        guaranteeMargin,
        txCryptoFee,
        stampDuty,
        txBankFee,
      }));
      setStaticValues({ goldValue, manufacturingCost });
    }
  }, [staticData]);

  const { data: eosKey, refetch } = useIsKeyAvailableQuery({ sessionId });

  useEffect(() => {
    dispatch(setPageTitle(pageTitle));
    // eslint-disable-next-line
  }, []);

  return (
    <Row>
      <Col lg={7}  className="mb-3 mb-lg-0">
        <Card bg="dark1 text-light">
          <Card.Body>
            <HOnePurchaseForm
              inputData={inputData}
              setInputData={setInputData}
              staticValues={staticValues}
              eosKey={eosKey}
              refetch={refetch}
              currency={currency}
              setCurrency={setCurrency}
              rate={rate}
            />
          </Card.Body>
        </Card>
      </Col>
      <Col lg={5}>
        <Card bg="dark1 text-light">
          <HOnePurchaseSummary
            inputData={inputData}
            eosKey={eosKey}
            currency={currency}
            rate={rate}
          />
        </Card>
      </Col>
    </Row>
  );
};

export default HeliorOne;
